<div [formGroup]="group">
  <mat-form-field appearance="outline" class="basic-input-field" [ngClass]="config.class">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <input matInput  type="number" placeholder="{{config.placeholder}}" [formControlName]="config.name" appIosMinusButton [attr.name]="config.name" >
    @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
      <mat-error>
        Min length validate 6
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
      <mat-error>
        Field Required Field
      </mat-error>
    }
  </mat-form-field>
</div>